<template>
  <div :id="uuid" class="p-8 bg-white rounded-xl">
    <div
      v-if="formData.description"
      :style="{ color: formData.textColor }"
      class="marked mb-2"
      v-html="$marked(formData.description)"
    />
    <div class="flex justify-center">
      <div
        class="w-full"
        :style="`max-width: ${
          formData.maxWidth ? formData.maxWidth + 'px' : 'auto'
        }`"
      >
        <BaseRatio
          :ratio="9 / 16"
          class="bg-black rounded-lg overflow-hidden w-full"
        >
          <iframe
            class="w-full h-full rounded-lg"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            credentialless
            anonymous
            :src="videoSrc"
          />
        </BaseRatio>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface FormDataInterface {
  title?: string
  description?: string
  textColor?: string
  source: string
  videoId: string
  maxWidth?: number
}

interface PropsInterface {
  formData: FormDataInterface
  uuid: string
}

const props = withDefaults(defineProps<PropsInterface>(), {
  formData: () => ({
    source: 'youtube',
    videoId: 'vb8NvZkck5c',
  }),
})

const videoSrc = computed(() => {
  if (props.formData.source === 'youtube') {
    return `https://www.youtube.com/embed/${
      props.formData.videoId
    }?origin=https://${useDomain()}`
  } else if (props.formData.source === 'gcore') {
    const [clientId] = props.formData.videoId.split('_')

    return `https://${clientId}.gvideo.io/videos/${props.formData.videoId}`
  } else if (props.formData.source === 'googledrive') {
    return `https://drive.google.com/file/d/${props.formData.videoId}/preview`
  } else {
    return ''
  }
})
</script>
